export default __webpack_public_path__ + "reduced-volume.png";